import clsx from 'clsx';
import type * as React from 'react';

import { CardButton, type CardButtonProps } from '@gitbook/spine-react';

type OnboardingActionProps = {
    title: string;
    icon?: React.ComponentType<{ size?: number; className?: string }>;
    className?: string;
    compact?: boolean;
    disabled?: boolean;
    onPress?: CardButtonProps['onPress'];
};

/**
 * Large button used by the onboarding screen to present mutually exclusive setup paths.
 */
export function OnboardingAction(props: OnboardingActionProps) {
    const { title, icon: IconComponent, className, compact, disabled, onPress } = props;

    return (
        <CardButton
            disabled={disabled}
            onPress={onPress}
            className={clsx(
                'flex w-full items-center justify-center gap-4 border border-neutral-subtle bg-base shadow-subtle transition-colors hover:bg-[--secondary-button-bg-hover] focus-visible:bg-[--secondary-button-bg-hover]',
                compact ? 'min-h-32 flex-col px-6 py-7 text-center' : 'min-h-18 px-6 py-4',
                className
            )}
        >
            {IconComponent ? <IconComponent size={compact ? 28 : 20} className="shrink-0" /> : null}
            <span className={compact ? 'max-w-64 text-ui-heading-small' : 'text-ui-heading-small'}>
                {title}
            </span>
        </CardButton>
    );
}
